<template>
  <div class="tsoft-header">
    <div class="d-flex align-items-center">
      <div>
        <router-link to="/dashboard">
          <img :src="'/img/logo-tanasoft.svg'" />
        </router-link>
      </div>
    </div>
    <div class="d-flex align-items-center ml-4" style="overflow-x: auto;">
      <!-- <div class="mr-3">
        <tsoft-sidebar-notifications />
      </div> -->
      <!-- <div class="mr-3">
        <router-link to="/profile">
          <div class="tsoft-user-preview">
            <template v-if="currentUser.avatar_path">
              <img :src="currentUser.avatar_path" alt="userPhoto" />
            </template>
            <template v-else>
              <b-avatar
                :title="currentUser.name"
                :size="28"
                variant="secondary"
                :text="nameAvatar(currentUser.name)"
              ></b-avatar>
            </template>
            <span class="font-weight-bold text-brown mx-2 hidden-from-1141">{{
              currentUser.name
            }}</span>
          </div>
        </router-link>
      </div> -->
      <div>
        <div @click="logout">
          <b-iconstack font-scale="2.5" class="cursor-pointer">
            <b-icon stacked icon="circle-fill" variant="light-gray"></b-icon>
            <b-icon
              stacked
              icon="door-open"
              scale="0.5"
              variant="brown"
            ></b-icon>
          </b-iconstack>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API_USERS_LISTS } from "@/constants";
import { mixinTasks } from "@/mixins";
import { mapGetters, mapActions } from "vuex";

import SidebarNotifications from "../notifications/SidebarNotifications.vue";

export default {
  mixins: [mixinTasks],
  components: {
    "tsoft-sidebar-notifications": SidebarNotifications,
  },
  data() {
    return {
      isOnlyForAccountant: false,
      internalUsers: [],
    };
  },

  computed: {
    ...mapGetters("auth", ["currentUser"]),
  },

  methods: {
    ...mapActions("auth", ["AUTH_LOGOUT"]),

    onlyForAccountant() {
      if (
        this.currentUser.role.includes("administrator") ||
        this.currentUser.role.includes("head-accountant") ||
        this.currentUser.role.includes("accountant")
      ) {
        this.isOnlyForAccountant = true;
        this.getAllFinanceUsers();
        return true;
      }
      return false;
    },
    getAllFinanceUsers() {
      api
        .call('get', `${API_USERS_LISTS}?list_type=for-accountants`)
        .then(({ data }) => {
          this.internalUsers = data;
          this.$store.dispatch('GET_NOTIFICATIONS');
        });
    },

    logout() {
      this.AUTH_LOGOUT().then(() => {
        this.$toast.success('Выход выполнен успешно. Хорошего дня! ☀️', {
          position: 'top-right',
          timeout: 3000,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: true,
          draggablePercent: 1,
          showCloseButtonOnHover: true,
          hideProgressBar: true,
          closeButton: "button",
          icon: 'fa fa-exclamation-triangle',
          rtl: false,
        });
        this.$router.push('/login');
      });
    },
  },
  mounted() {
    this.onlyForAccountant();
  },
};
</script>
